// import PropTypes from "prop-types";
import React, { FC, Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { useTranslation } from "react-i18next";

import { RootState } from "../store";
import useAppDispatch from "../hooks/useAppDispatch";
import { payloadProduct } from "../types/products";
import { getProductsRegisterList } from "../store/action/products";

const MBizProduct: FC<{ limit: number; type: number }> = ({ limit, type }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const products = useSelector(
    (state: RootState) => state.product.productRegister,
  );

  const getProductsLists = async () => {
    const payload: payloadProduct = {
      pageSize: limit,
      pageNo: 0,
      orderDirection: "",
      categoryId: 0,
      displayType: type,
      priceTo: 0,
      priceFrom: 0,
      orderColumn: "Price",
    };
    await dispatch(getProductsRegisterList(payload));
  };

  useEffect(() => {
    getProductsLists();
  }, []);

  if (!products?.length) return <p>No products found</p>;

  return (
    <div className="products-area">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* section title */}
            <h2 className="section-title space-mb--20">
              OTTO MALL
              <Link to={process.env.PUBLIC_URL + "/products/ottoMall"}>
                {t("view all")}{" "}
                <span>
                  <ReactSVG
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/img/icons/arrow-right.svg"
                    }
                  />
                </span>
              </Link>
            </h2>

            {/* featured products */}
            <div className="all-products-wrapper space-mb-m--20">
              <div className="row">
                {products.map((item) => {
                  return (
                    <div className="col-6" key={item.id}>
                      <div className="grid-product space-mb--20">
                        <div className="grid-product__image">
                          <Link
                            to={
                              process.env.PUBLIC_URL +
                              `/product/mbiz/${item.id}`
                            }
                          >
                            <img
                              src={item.imageUrl}
                              className="img-fluid"
                              alt=""
                            />
                          </Link>
                        </div>
                        <div className="grid-product__content">
                          <h3 className="title">
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                `/product/mbiz/${item.id}`
                              }
                            >
                              {item.name}
                            </Link>
                          </h3>
                          <span className="point">{item.pv} PV</span>
                          <div className="price">
                            {t("usd")} {item.price}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MBizProduct;
